import {apiUri} from '../../config/environment';
import {STRAPI_DEVELOPMENT, STRAPI_PRODUCTION} from '../../constants/Api';
import Auth from './auth';

export const registerUser = async (data) => {
  return new Promise(async (resolve, reject) => {
    await fetch(
      process.env.NODE_ENV === 'production'
      ? `${STRAPI_PRODUCTION}/auth/local/register`
      : `${STRAPI_DEVELOPMENT}/auth/local/register`,
      {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    
    })
      .then(async (value) => {
        const data = await value.json();
        if (!!data.jwt) {
          data['success'] = true;
          Auth.saveToken(data.jwt);
          Auth.saveUser(data.user);
        } else {
          data['success'] = false;
        }
        resolve(data);
      })
      .catch((error) => {
        data['success'] = false;
        reject(error);
      });
  });
};

export const fetchToken = (identifier, password) => {
  return new Promise(async (res, rej) => {
    await fetch(
      process.env.NODE_ENV === 'production'
        ? `${STRAPI_PRODUCTION}/auth/local`
        : `${STRAPI_DEVELOPMENT}/auth/local`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          identifier,
          password,
        }),
      },
    )
      .then(async (data) => {
        return await data.json();
      })
      .then((json) => {
        res(json);
      })
      .catch((err) => rej(err));
  });
};
